import api from "./api";

export const DARYL_PILOT_ID = "daryl-lincforge-v1";

export async function getForPilot(pilotId = DARYL_PILOT_ID) {
  const { data } = await api.get(`/for/pilots/${pilotId}`);
  return data;
}

export async function createForCapture(category, text, pilotId = DARYL_PILOT_ID) {
  const { data } = await api.post(`/for/pilots/${pilotId}/captures`, { category, text });
  return data;
}

export async function confirmForCapture(captureId) {
  const { data } = await api.post(`/for/captures/${captureId}/confirm`);
  return data;
}

export async function updateForJob(jobId, fields) {
  const { data } = await api.patch(`/for/jobs/${jobId}`, fields);
  return data;
}

export async function createForRevision(jobId, payload) {
  const { data } = await api.post(`/for/jobs/${jobId}/revisions`, payload);
  return data;
}

export async function createForFeedback(jobId, payload) {
  const { data } = await api.post(`/for/jobs/${jobId}/feedback`, payload);
  return data;
}
